import React, { useState } from 'react';
import './MediaSection.css';
import img from './photos/news2.jpeg';
import img1 from './photos/news3.jpeg';
import img2 from './photos/news4.jpeg';
import { Fade } from "react-awesome-reveal";

const MediaSection = () => {
    const [popupImage, setPopupImage] = useState(null);
    const [popupVideo, setPopupVideo] = useState(null);

    const handleDoubleClick = (src) => {
        setPopupImage(src);
    };

    const handleVideoClick = (videoSrc) => {
        setPopupVideo(videoSrc);
    };

    const closePopup = () => {
        setPopupImage(null);
        setPopupVideo(null);
    };

    return (
        <div className="media-section">
            <Fade direction="down" triggerOnce={false}>
                <h2 className="section-title">Latest Highlights</h2>
            </Fade>
            <div className="media-grid">

                {/* Video 1 */}
                <Fade direction="left" triggerOnce={false}>
                    <div className="media-item video-container">
                        <div 
                            className="video-overlay" 
                            onClick={() => handleVideoClick("https://www.youtube.com/embed/SbvIdNi-EV0")}
                        ></div>
                        <iframe
                            src="https://www.youtube.com/embed/SbvIdNi-EV0"
                            title="Video 1"
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                    </div>
                </Fade>

                {/* Image 1 */}
                <Fade direction="down" triggerOnce={false}>
                    <div className="media-item newspaper-container" onDoubleClick={() => handleDoubleClick(img)}>
                        <img src={img} alt="News 1" />
                        <div className="hover-text">Double click to read</div>
                    </div>
                </Fade>

                {/* Video 2 */}
                <Fade direction="right" triggerOnce={false}>
                    <div className="media-item video-container">
                        <div 
                            className="video-overlay" 
                            onClick={() => handleVideoClick("https://www.youtube.com/embed/MSsB_zD2uzA")}
                        ></div>
                        <iframe
                            src="https://www.youtube.com/embed/MSsB_zD2uzA"
                            title="Video 2"
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                    </div>
                </Fade>

                {/* Image 2 */}
                <Fade direction="left" triggerOnce={false}>
                    <div className="media-item newspaper-container" onDoubleClick={() => handleDoubleClick(img1)}>
                        <img src={img1} alt="News 2" />
                        <div className="hover-text">Double click to read</div>
                    </div>
                </Fade>

                {/* Video 3 */}
                <Fade direction="up" triggerOnce={false}>
                    <div className="media-item video-container">
                        <div 
                            className="video-overlay" 
                            onClick={() => handleVideoClick("https://www.youtube.com/embed/ixQMa-0bV3I")}
                        ></div>
                        <iframe
                            src="https://www.youtube.com/embed/ixQMa-0bV3I"
                            title="Video 3"
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                    </div>
                </Fade>

                {/* Image 3 */}
                <Fade direction="right" triggerOnce={false}>
                    <div className="media-item newspaper-container" onDoubleClick={() => handleDoubleClick(img2)}>
                        <img src={img2} alt="News 3" />
                        <div className="hover-text">Double click to read</div>
                    </div>
                </Fade>
            </div>

            {/* Image Popup */}
            {popupImage && (
                <div className="popup-overlay" onClick={closePopup}>
                    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-btn" onClick={closePopup}>&times;</button>
                        <img src={popupImage} alt="Popup Enlarged" />
                    </div>
                </div>
            )}

            {/* Fullscreen Video Popup */}
            {popupVideo && (
                <div className="popup-overlay video-fullscreen" onClick={closePopup}>
                    <div className="video-wrapper" onClick={(e) => e.stopPropagation()}>
                        <button className="close-btn" onClick={closePopup}>&times;</button>
                        <iframe
                            src={popupVideo + "?autoplay=1"}
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MediaSection;
